import axios from "axios";
import React, { useState, useEffect } from "react";
import ReactStars from "react-stars";

export default function Rating({ dCv, userId }) {
    const [currentRating, setCurrentRating] = useState(0);
    const [hasRated, setHasRated] = useState(false);

    useEffect(() => {
        const fetchRating = async () => {
            try {
                const response = await axios.get(`/ratingwhere`, {
                    params: {
                        cv_id: dCv.id,
                        user_id: userId
                    }
                });

                if (response.status === 200 && response.data) {
                    if(response.data != ''){
                        setCurrentRating(response.data[0]);
                        setHasRated(true);
                    }
                } else {
                    setHasRated(false);
                }
            } catch (error) {
                console.error('Error fetching rating:', error.response ? error.response.data : error.message);
            }
        };

        fetchRating();
    }, [dCv.id, userId]);
    
    const handleRatingChange = async (newRating) => {
        try {
            const ratingData = {
                rate: newRating,
                user_id: userId,
                cv_id: dCv.id
            };

            if (hasRated) {
                // Update existing rating
                await axios.put(`/ratings/${currentRating.id}`, ratingData);
            } else {
                // Create new rating
                const response = await axios.post(`/ratings`, ratingData);
                setHasRated(true);
                setCurrentRating(newRating); // Set the returned rating as the current rating
            }

            setCurrentRating(newRating);
        } catch (error) {
            console.error('Error updating rating:', error.response ? error.response.data : error.message);
        }
    };

    return (
        <ReactStars
            count={5}
            value={currentRating.rate} // Display the current rating as yellow stars
            size={24}
            color2={"#ffd700"} // Yellow color for rated stars
            color1={"#cccccc"} // Gray color for unrated stars
            half={false} // Disable half-stars
            onChange={handleRatingChange} // Enable star rating change on click
        />
    );
}
